import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/services/firebase';

// Stored at users/{uid}/preferences/favorites with shape { list: string[] }.
// Kept as a single doc (not a collection of one-doc-per-favorite) so reads
// and writes are atomic and we never need a query.

const favRef = (uid: string) => doc(db, 'users', uid, 'preferences', 'favorites');

export async function fetchFavorites(uid: string): Promise<string[] | null> {
  const snap = await getDoc(favRef(uid));
  if (!snap.exists()) return null;
  const data = snap.data();
  if (!Array.isArray(data.list)) return [];
  return data.list.filter((v: unknown): v is string => typeof v === 'string');
}

export async function writeFavorites(uid: string, list: string[]): Promise<void> {
  await setDoc(favRef(uid), { list, updatedAt: serverTimestamp() }, { merge: true });
}
